import React from "react";
import { useUserPermissions, hasPermission } from "./permissions";

const PermissionChecker = ({ children, requiredPermissions }) => {
  const userPermissions = useUserPermissions(); 

  
  const hasRequiredPermissions = hasPermission(userPermissions, requiredPermissions);

  
  return hasRequiredPermissions ? <>{children}</> : null;
};

export default PermissionChecker;
